import { FieldPath, FieldValues, FormState } from 'react-hook-form';
import { isObject } from '../../jsUtils';

const buildPath = (base: string, key: string | number) =>
  base ? `${base}.${key}` : String(key);

/**
 * Extracts field paths from dirtyFields object.
 * dirtyFields has same structure as form values but with `true` for modified fields.
 */
export const getDirtyFieldPaths = <T extends FieldValues>(
  dirtyFields: FormState<T>['dirtyFields'],
  path = '',
): FieldPath<T>[] =>
  Object.entries(dirtyFields).flatMap(([key, value]) => {
    const currentPath = buildPath(path, key);

    if (value === true) {
      return currentPath;
    }

    if (isObject(value)) {
      return getDirtyFieldPaths(value as FormState<T>['dirtyFields'], currentPath);
    }

    if (Array.isArray(value)) {
      return value.flatMap((item, index) => {
        if (item === true) {
          return buildPath(currentPath, index);
        }
        if (isObject(item)) {
          return getDirtyFieldPaths(
            item as FormState<T>['dirtyFields'],
            buildPath(currentPath, index),
          );
        }
        return [];
      });
    }

    return [];
  }) as FieldPath<T>[];
